import { ReactNode } from "react";
import { ClipboardCheckIcon } from "lucide-react";
import { FieldValues, UseFormReturn } from "react-hook-form";

import { Column, KeyboardShortcut, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import { CollapsibleContent } from "@/components/ui/collapsible";
import { Form } from "@/components/ui/form";

import { dates } from "@/lib/dates";

export const ConfigFormWrapper = <T extends FieldValues>({
  buttonLabel,
  children,
  disabled,
  form,
  lastUpdated,
  onKeyDown,
  onSubmit,
}: {
  buttonLabel: string;
  children: ReactNode;
  disabled?: boolean;
  form: UseFormReturn<T>;
  lastUpdated?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLFormElement>) => void;
  onSubmit: (data: T) => void;
}) => {
  return (
    <CollapsibleContent>
      <Form {...form}>
        <form
          className="flex flex-col"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onSubmit={form.handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.metaKey && !e.shiftKey) {
              e.preventDefault();
            }
            if (e.metaKey && e.key === "Enter") {
              e.preventDefault();
              void form.handleSubmit(onSubmit)();
            }
            onKeyDown?.(e);
          }}
        >
          <Column className="gap-4 border-t border-slate-100 px-6 pb-5 pt-4">
            {children}
          </Column>
          <Row className="items-center justify-between border-t border-slate-100 px-6 py-3">
            {lastUpdated ? (
              <Text className="text-xs text-slate-400">
                Last Updated: {dates.formatIsoDateForUser(lastUpdated)}
              </Text>
            ) : (
              <span />
            )}
            <Button disabled={disabled} type="submit">
              <ClipboardCheckIcon className="h-4 w-4" />
              {buttonLabel}
              <KeyboardShortcut text="⌘↵" />
            </Button>
          </Row>
        </form>
      </Form>
    </CollapsibleContent>
  );
};
